import { render, staticRenderFns } from "./Stripe.vue?vue&type=template&id=2ca4b2b6&scoped=true&"
import script from "./Stripe.vue?vue&type=script&lang=js&"
export * from "./Stripe.vue?vue&type=script&lang=js&"
import style0 from "./Stripe.vue?vue&type=style&index=0&id=2ca4b2b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca4b2b6",
  null
  
)

export default component.exports